import * as CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';
import ls from 'localstorage-slim';
import { PRIVATE_KEY } from 'src/app/app.constants';
import { environment } from 'src/environments/environment';

ls.config.encrypt = true;

// Create a single shared JSEncrypt instance
export const $encrypt: any = new JSEncrypt({
  default_key_size: '2048'
});

export const sign = (str: string): string => {
  const text: string = `${str}`.trim();
  const hexText: string = toHexString(text);

  if (environment.production === false) {
    const storedPrivateKey = ls.get(PRIVATE_KEY);
    if (storedPrivateKey) {
      $encrypt.setPrivateKey(storedPrivateKey);
    } else {
      const newPrivateKey = $encrypt.getPrivateKeyB64();
      ls.set(PRIVATE_KEY, newPrivateKey);
      $encrypt.setPrivateKey(newPrivateKey);
    }
  }

  // Sign with SHA256 and return base64 encoded signature
  const signature = $encrypt.sign(hexText, CryptoJS.SHA256, 'sha256');
  return signature;
};

function toHexString(str: String): string {
  const byteArray = toUTF8Array(str);
  return Array.prototype.map
    .call(byteArray, function (byte) {
      return ('0' + (byte & 0xff).toString(16)).slice(-2);
    })
    .join('')
    .toUpperCase();
}

function toUTF8Array(str: String): number[] {
  let utf8 = [];
  for (let i = 0; i < str.length; i++) {
    let charCode = str.charCodeAt(i);
    if (charCode < 0x80) utf8.push(charCode);
    else if (charCode < 0x800) {
      utf8.push(0xc0 | (charCode >> 6), 0x80 | (charCode & 0x3f));
    } else if (charCode < 0xd800 || charCode >= 0xe000) {
      utf8.push(
        0xe0 | (charCode >> 12),
        0x80 | ((charCode >> 6) & 0x3f),
        0x80 | (charCode & 0x3f)
      );
    } else {
      i++;
      charCode = ((charCode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff);
      utf8.push(
        0xf0 | (charCode >> 18),
        0x80 | ((charCode >> 12) & 0x3f),
        0x80 | ((charCode >> 6) & 0x3f),
        0x80 | (charCode & 0x3f)
      );
    }
  }
  return utf8;
}
